/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReturnFromCoupangConfirmReceiveAddressVo } from './ReturnFromCoupangConfirmReceiveAddressVo';
import {
    ReturnFromCoupangConfirmReceiveAddressVoFromJSON,
    ReturnFromCoupangConfirmReceiveAddressVoFromJSONTyped,
    ReturnFromCoupangConfirmReceiveAddressVoToJSON,
    ReturnFromCoupangConfirmReceiveAddressVoToJSONTyped,
} from './ReturnFromCoupangConfirmReceiveAddressVo';

/**
 * 
 * @export
 * @interface ReturnFromCoupangConfirmVo
 */
export interface ReturnFromCoupangConfirmVo {
    /**
     * 本次确认的最终处理方式；申请时预选仅供参考，库存方式另校验全部商品已注册。
     * 本次确认的最终返送处理方式：1废弃，2韩国库存，3韩国快递，4橙火入仓一般快递，5橙火入仓官方揽收快递，6橙火入仓官方揽收托盘，7待定
     * @type {number}
     * @memberof ReturnFromCoupangConfirmVo
     */
    returnProcessMethod?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof ReturnFromCoupangConfirmVo
     */
    userId?: number;
    /**
     * 订单ID
     * @type {number}
     * @memberof ReturnFromCoupangConfirmVo
     */
    orderId?: number;
    /**
     * 
     * @type {ReturnFromCoupangConfirmReceiveAddressVo}
     * @memberof ReturnFromCoupangConfirmVo
     */
    returnFromCoupangConfirmReceiveAddressVO?: ReturnFromCoupangConfirmReceiveAddressVo;
}

/**
 * Check if a given object implements the ReturnFromCoupangConfirmVo interface.
 */
export function instanceOfReturnFromCoupangConfirmVo(value: object): value is ReturnFromCoupangConfirmVo {
    return true;
}

export function ReturnFromCoupangConfirmVoFromJSON(json: any): ReturnFromCoupangConfirmVo {
    return ReturnFromCoupangConfirmVoFromJSONTyped(json, false);
}

export function ReturnFromCoupangConfirmVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnFromCoupangConfirmVo {
    if (json == null) {
        return json;
    }
    return {
        
        'returnProcessMethod': json['returnProcessMethod'] == null ? undefined : json['returnProcessMethod'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'returnFromCoupangConfirmReceiveAddressVO': json['returnFromCoupangConfirmReceiveAddressVO'] == null ? undefined : ReturnFromCoupangConfirmReceiveAddressVoFromJSON(json['returnFromCoupangConfirmReceiveAddressVO']),
    };
}

export function ReturnFromCoupangConfirmVoToJSON(json: any): ReturnFromCoupangConfirmVo {
    return ReturnFromCoupangConfirmVoToJSONTyped(json, false);
}

export function ReturnFromCoupangConfirmVoToJSONTyped(value?: ReturnFromCoupangConfirmVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnProcessMethod': value['returnProcessMethod'],
        'userId': value['userId'],
        'orderId': value['orderId'],
        'returnFromCoupangConfirmReceiveAddressVO': ReturnFromCoupangConfirmReceiveAddressVoToJSON(value['returnFromCoupangConfirmReceiveAddressVO']),
    };
}

